


//  export const ="/klikfmdev"
export const PATH = {
  PAGE_NOT_FOUND: "*",
  DEFAULT: "/",
  DASHBOARD: `/dashboard`,
  LOGIN: `/login`,
  USERROLEMASTER: `/userrolemasterlist`,
  SKILLMASTER: `/skillmasterlist`,
  USERMASTER: `/usermasterlist`,
  USERROLE_RIGHT: `/roleandright`,
  USERSKILLMSATER: `/userskillmaster`,
  LOCATIONTYPE: `/locationtype`,
  ADDBUILDING: `/addfacilitysetup`,
  BUILDINGSETUP: `/facilitydetail`,
  ADDLOCATION: `/location`,
  LANGUAGECHANGE: `/languageChange`,
  MAKEMASTER: `/makemaster`,
  TASKMASTER: `/taskmasterlist`,
  MODELMASTER: `/modelmaster`,
  ASSETGROUPMASTER: `/assetgroupmaster`,
  SERVICEGROUPMASTER: `/servicegroupmaster`,
  ASSETTYPEMASTER: `/assettypemaster`,
  SERVICETYPEMASTER: `/servicetypemaster`,
  UOMMASTER: `/uommaster`,
  ASSETMASTER: `/assetmasterlist`,
  PARTMASTER: `/partmasterlist`,
  SEVERITYMASTER: `/severitylist`,
  CREDENTIALCONFIGMASTER: `/credentiaconfigllist`,
  WORKORDERTYPE: `/workordertypelist`,
  WORKORDERSTATUS: `/workorderstatuslist`,
  CURRENTSTATUSCONFIG: `/currentstatusconfig`,
  STOREMASTER: `/storesetuplist`,
  RACKMASTER: `/rackmasterlist`,
  WEEKOFMASTER: `/weekoffmasterlist`,
  ASSETMASTERCONFIGURATION: `/assetmasterconfiguration`,
  REQDESCRIPTIONMASTER: `/requestdescriptionlist`,
  WORKORDERMASTER: `/workorderlist`,
  SAVENUMBERRANGECONFIG: `/numberrangeconfig`,
  VENDORMASTER: `/vendoremasterlist`,
  VENDORMANAGEMENT: `/vendorsor`,
  VENDORSORCOMPARISION: `/vendorsorcomparison`,
  SERVICEMASTER: `/servicemasterlist`,
  TEAMMASTER: `/teammasterlist`,
  EVENTMASTER: `/eventmasterlist`,
  ESCALATIONMATRIX: `/escalationmatrixlist`,
  PPMSCHEDULE: `/ppmSchedule`,
  INFRAPPMSCHEDULE: `/ppmSchedule1`,
  MATERIALREQUEST: `/materialrequestlist`,
  ISSUEMATERIAL: `/issuemateriallist`,
  RETURNMATERIAL: `/returnmateriallist`,
  STORETOSTORE: `/storetostorelist`,
  SERVICEREQUEST: `/servicerequestlist`,
  INVENTORYMASTER: `/addinventory`,
  PPMSCHEDULEDETAILS: `/ppmscheduledetails`,
  ASSETSCHEDULEMASTER: `/assettaskschedulelist`,
  MATERIALREQUESTPROVISION: `/materialrequestapprovelist`,
  ANALYTICSPLATEFORMASSETLINK: `/linkananlyticsplatformlist`,
  ANANLYTICSFDD: `/ananlyticsfddlist`,
  REASONMASTER: `/reasonmasterlist`,
  RECTIFIEDCOMMENT: `/rectifiedcommentlist`,
  SHOWSERVICEREQEST: `/servicerequestlist?edit=`,
  ADD_PPMSCHEDULE: `/ppmSchedule?add=`,
  ADD_ISSUEMATERIAL: `/issuemateriallist?add=`,
  EDIT_WORKORDERMASTER: `/workorderlist?edit=`,
  EDIT_ESCALATIONMATRIX: `/escalationmatrixlist?edit=`,
  ADD_ESCALATIONMATRIX: `/escalationmatrixlist?add=`,
  LOGDETAILS: `/LogsDetails`,
  INFRASCEDULE: `/infraschedule`,
  ACTION_MASTER: `/actionstatuslist`,
  VENDOR_CONTRACT: `/vendorcontract`,
  ASSET_HIERARCHY: `/equipmenthierarchy`,
  ADD_ASSET_HIERARCHY: `/addequipmenthierarch`,
  INFRA_SERVICE_REQUEST: `/infraservicerequest`,
  USER_ACTION_DETAILS: `/actionstatusconfig`,
  PDF_REPORT: `/pdfreport`,
  WORKORDERMASTER_DETAILS: `/workorderlist?edit=/:id`,
  REPORT: `/reports`,
  INFRA_SCHEDULE_ADD: `/assettaskschedulelist?add=`,
  INFRA_SCHEDULE_EDIT: `/assettaskschedulelist?edit=`,
  INFR_PPMSCHEDULEDETAILS: `/infrappmscheduledetails`,
  INFRA_SERVICE_REQUEST_ADD: `/infraservicerequest?add=`,
  INFRA_REPORT_TEMPLATE: `/reporttemplateconfig`,
  MAINTENANCEBANNERCONFIG:`/maintenanceconfiguration`,
  ARCHIVED_WORK_ORDER: `/archived-work-order`,
};
